const Icon = (props: any) => {
    return (
        <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M1 1l10 10M11 1L1 11"
                stroke="currentColor"
                strokeWidth={props.strokeWidth || 2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Icon;
